import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocaleService } from 'src/app/services/locale.service';
import { Theme } from 'src/app/models/theme';
import { ThemeService } from 'src/app/services/theme.service';
import { AuthService } from 'src/app/api/auth.service';

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss']
})
export class ExchangeComponent implements OnInit, OnDestroy {
  lang: string;
  isLoggedIn: boolean;

  constructor(
    private auth: AuthService,
    private localeService: LocaleService,
    private themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.themeService.set(Theme.Dark);
    this.lang = this.localeService.currentLocale;
    this.isLoggedIn = !!this.auth.getToken();

  }

  ngOnDestroy() {
    this.themeService.remove();
  }

}
